import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function getAllVipInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/vip/get-all-vip-info',
    method: 'post',
    data: object
  })
}

export function getRebateInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/vip/get-rebate-info',
    method: 'post',
    data: object
  })
}

export function getAllSpecialVipInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: 'vip/get-all-special-vip-info',
    method: 'post',
    data: object
  })
}
